export default "__VITE_ASSET__0150d11d__"